import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import OneClickButton from '../../../../components/form/button';

import Form from '../../../../components/form/form';
import {
  Panel,
  PanelBody, PanelFooter,
  PanelHeader,
} from '../../../../components/panel/panel';
import addNotification from '../../../../components/notification';

import ROUTES from '../../../../config/routes';

import {
  getQRCodeConfig, createQRCodeConfig, updateQRCodeConfig,
} from '../../../../app/store/actions/QRCodeConfig';

class QRCodeConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'detail',
      code: '',
      disableCode: true,
      description: '',
      disableDescription: true,
      separator: '',
      disableSeparator: true,
      productCodePosition: '',
      disableProductCodePosition: true,
      lotNumberPosition: '',
      disableLotNumberPosition: true,
      expirationDatePosition: '',
      disableExpirationDatePosition: true,
      expirationDateFormat: '',
      disableExpirationDateFormat: true,
      manufacturingDatePosition: '',
      disableManufacturingDatePosition: true,
      manufacturingDateFormat: '',
      disableManufacturingDateFormat: true,
      quantityPosition: '',
      disableQuantityPosition: true,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
    };
  }

  async componentDidMount() {
    await this.setMode();
    if (this.state.mode !== 'create') {
      await this.getQRCodeConfigSelected();
    }
  }

  setMode = () => {
    let mode = '';
    if (this.props.isCreate) mode = 'create';
    else if (this.props.isCopy) mode = 'copy';
    else if (this.props.isEdit) mode = 'edit';
    else if (this.props.isDetail) mode = 'detail';

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableCode: false,
        disableDescription: false,
        disableSeparator: false,
        disableProductCodePosition: false,
        disableLotNumberPosition: false,
        disableExpirationDatePosition: false,
        disableExpirationDateFormat: false,
        disableManufacturingDatePosition: false,
        disableManufacturingDateFormat: false,
        disableQuantityPosition: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableCode: true,
        disableDescription: false,
        disableSeparator: false,
        disableProductCodePosition: false,
        disableLotNumberPosition: false,
        disableExpirationDatePosition: false,
        disableExpirationDateFormat: false,
        disableManufacturingDatePosition: false,
        disableManufacturingDateFormat: false,
        disableQuantityPosition: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
      });
    }
  };

  setValue = async (attr, value) => {
    if (attr === 'expirationDateFormat' || attr === 'manufacturingDateFormat') {
      const dateFormat = value.toUpperCase();
      const regex = /^[DMAY]{0,10}$/;

      if (!regex.test(dateFormat)) return;

      await this.setState({
        [`${attr}`]: dateFormat,
      });
    } else {
      await this.setState({
        [`${attr}`]: value,
      });
    }
  };

  setValueDrop = async (attr, value) => {
    await this.setState({
      [`${attr}Code`]: value ? value.value : '',
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  getQRCodeConfigSelected = async () => {
    if (this.props.location.state.QRCodeConfig) {
      const { QRCodeConfig } = this.props.location.state;
      const QRCodeConfigSelected = await this.props.getQRCodeConfig(QRCodeConfig.id);

      if (QRCodeConfigSelected) {
        this.setState({
          qrCodeConfigId: QRCodeConfigSelected.id,
          code: QRCodeConfigSelected.code,
          description: QRCodeConfigSelected.description,
          separator: QRCodeConfigSelected.separator,
          productCodePosition: QRCodeConfigSelected.productCodePosition,
          lotNumberPosition: QRCodeConfigSelected.lotNumberPosition,
          expirationDatePosition: QRCodeConfigSelected.expirationDatePosition,
          expirationDateFormat: QRCodeConfigSelected.expirationDateFormat,
          manufacturingDatePosition: QRCodeConfigSelected.manufacturingDatePosition,
          manufacturingDateFormat: QRCodeConfigSelected.manufacturingDateFormat,
          quantityPosition: QRCodeConfigSelected.quantityPosition,
        });
      }
    }
  };

  createQRCodeConfigSubmit = async () => {
    const {
      code,
      description,
      separator,
      productCodePosition,
      lotNumberPosition,
      expirationDatePosition,
      expirationDateFormat,
      manufacturingDatePosition,
      manufacturingDateFormat,
      quantityPosition,
    } = this.state;

    if (expirationDatePosition) {
      if (!expirationDateFormat) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4610', /* É necessário informar o formato do campo %{0}. */
            { 0: I18n.t('BEE2035' /* Data Vencimento */) },
          ),
          'top-right',
        );
        return;
      }
      if (!this.validateDateFormat(expirationDateFormat)) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4611', /* Formato inválido do campo %{0}. */
            { 0: I18n.t('BEE2035' /* Data Vencimento */) },
          ),
          'top-right',
        );
        return;
      }
    }

    if (manufacturingDatePosition) {
      if (!manufacturingDateFormat) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4610', /* É necessário informar o formato do campo %{0}. */
            { 0: I18n.t('BEE488' /* Data de Fabricação */) },
          ),
          'top-right',
        );
        return;
      }
      if (!this.validateDateFormat(manufacturingDateFormat)) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4611', /* Formato inválido do campo %{0}. */
            { 0: I18n.t('BEE488' /* Data de Fabricação */) },
          ),
          'top-right',
        );
        return;
      }
    }

    try {
      const newQRCodeConfig = await this.props.createQRCodeConfig({
        code,
        description,
        separator,
        productCodePosition,
        lotNumberPosition,
        expirationDatePosition,
        expirationDateFormat,
        manufacturingDatePosition,
        manufacturingDateFormat,
        quantityPosition,
      });

      if (newQRCodeConfig) {
        await addNotification(
          'success',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t('BEE4599' /* Configurador de QR Code incluído com sucesso. */),
          'top-right',
        );

        this.props.history.push(ROUTES.QR_CODE_CONFIG_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4590' /* Configurador de QR Code */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4590' /* Configurador de QR Code */),
            I18n.t('BEE4600' /* Erro ao incluir Configurador de QR Code. */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t('BEE4600' /* Erro ao incluir Configurador de QR Code. */),
          'top-right',
        );
      }
    }
  };

  updateQRCodeConfigSubmit = async () => {
    const {
      qrCodeConfigId,
      code,
      description,
      separator,
      productCodePosition,
      lotNumberPosition,
      expirationDatePosition,
      expirationDateFormat,
      manufacturingDatePosition,
      manufacturingDateFormat,
      quantityPosition,
    } = this.state;

    if (expirationDatePosition) {
      if (!expirationDateFormat) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4610', /* É necessário informar o formato do campo %{0}. */
            { 0: I18n.t('BEE2035' /* Data Vencimento */) },
          ),
          'top-right',
        );
        return;
      }
      if (!this.validateDateFormat(expirationDateFormat)) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4611', /* Formato inválido do campo %{0}. */
            { 0: I18n.t('BEE2035' /* Data Vencimento */) },
          ),
          'top-right',
        );
        return;
      }
    }

    if (manufacturingDatePosition) {
      if (!manufacturingDateFormat) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4610', /* É necessário informar o formato do campo %{0}. */
            { 0: I18n.t('BEE488' /* Data de Fabricação */) },
          ),
          'top-right',
        );
        return;
      }
      if (!this.validateDateFormat(manufacturingDateFormat)) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t(
            'BEE4611', /* Formato inválido do campo %{0}. */
            { 0: I18n.t('BEE488' /* Data de Fabricação */) },
          ),
          'top-right',
        );
        return;
      }
    }

    try {
      const updUser = await this.props.updateQRCodeConfig({
        qrCodeConfigId,
        code,
        description,
        separator,
        productCodePosition,
        lotNumberPosition,
        expirationDatePosition,
        expirationDateFormat,
        manufacturingDatePosition,
        manufacturingDateFormat,
        quantityPosition,
      });

      if (updUser) {
        await addNotification(
          'success',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t('BEE4601' /* Atualização do Configurador de QR Code efetuada com sucesso. */),
          'top-right',
        );

        this.props.history.push(ROUTES.QR_CODE_CONFIG_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4590' /* Configurador de QR Code */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4590' /* Configurador de QR Code */),
            I18n.t('BEE4602' /* Erro ao atualizar o Configurador de QR Code. */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t('BEE4602' /* Erro ao atualizar o Configurador de QR Code. */),
          'top-right',
        );
      }
    }
  };

  validateDateFormat = (format) => {
    const value = format.toUpperCase();

    // apenas letras permitidas e limite de tamanho
    if (!/^[DMAY]{6,10}$/.test(value)) return false;

    const count = (char) => (value.match(new RegExp(char, 'g')) || []).length;

    const d = count('D');
    const m = count('M');
    const a = count('A');
    const y = count('Y');

    // dia e mês obrigatórios
    if (d !== 2 || m !== 2) return false;

    // ano válido
    const yearValid = ((a === 2 || a === 4) && y === 0)
      || ((y === 2 || y === 4) && a === 0);

    if (!yearValid) return false;

    return true;
  };

  render() {
    const {
      mode, separator, disableSeparator, code, disableCode, description, disableDescription,
      productCodePosition, disableProductCodePosition, lotNumberPosition, disableLotNumberPosition,
      expirationDatePosition, disableExpirationDatePosition, expirationDateFormat, disableExpirationDateFormat,
      manufacturingDatePosition, disableManufacturingDatePosition, manufacturingDateFormat,
      disableManufacturingDateFormat, quantityPosition, disableQuantityPosition, showCancel,
      showCreate, showUpdate,
    } = this.state;

    let title = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE4591' /* Novo Configurador de QR Code */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE4592' /* Editar Configurador de QR Code */);
    } else if (mode === 'detail') {
      title = I18n.t('BEE4593' /* Detalhes do Configurador de QR Code */);
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE4590' /* Configurador de QR Code */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {title}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <Panel className="panel-with-tabs">
              <PanelHeader noButton />
              <PanelBody>
                <div className="row">
                  <div className="col-xl-12">
                    <Form
                      noPanel
                      setValue={this.setValue}
                      setValueDrop={this.setValueDrop}
                      inputs={(formContext) => ([
                        formContext.createInput(
                          code,
                          'code',
                          `${I18n.t('BEE82' /* Código */)}:`,
                          I18n.t('BEE3686' /* Informe o código */),
                          'text',
                          true,
                          disableCode,
                        ),
                        formContext.createInput(
                          description,
                          'description',
                          `${I18n.t('BEE1897' /* Descrição */)}:`,
                          I18n.t('BEE3477' /* Informe a descrição */),
                          'text',
                          true,
                          disableDescription,
                        ),
                        formContext.createInput(
                          separator,
                          'separator',
                          `${I18n.t('BEE1092' /* Separador */)}:`,
                          I18n.t('BEE3879' /* Informe o separador. */),
                          'text',
                          true,
                          disableSeparator,
                          undefined,
                          5,
                          undefined,
                          null,
                          1,
                        ),
                      ])}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="d-flex align-items-center mb-md-3 mb-1">
                    <h1 className="page-header mb-0">
                      {I18n.t('BEE3937' /* Posição */)}
                    </h1>
                  </div>
                  <div className="col-xl-12">
                    <Form
                      noPanel
                      setValue={this.setValue}
                      setValueDrop={this.setValueDrop}
                      inputs={(formContext) => [
                        formContext.createInput(
                          productCodePosition,
                          'productCodePosition',
                          `${I18n.t('BEE378' /* Código do Produto */)}:`,
                          `${I18n.t(
                            'BEE4594', /* Informe a posição do campo %{0}. */
                            { 0: I18n.t('BEE378' /* Código do Produto */) },
                          )}`,
                          'number',
                          false,
                          disableProductCodePosition,
                          undefined,
                          3,
                        ),
                        formContext.createInput(
                          lotNumberPosition,
                          'lotNumberPosition',
                          `${I18n.t('BEE1091' /* Número do lote */)}:`,
                          `${I18n.t(
                            'BEE4594', /* Informe a posição do campo %{0}. */
                            { 0: I18n.t('BEE1091' /* Número do lote */) },
                          )}`,
                          'number',
                          false,
                          disableLotNumberPosition,
                          undefined,
                          3,
                        ),
                        formContext.createInput(
                          expirationDatePosition,
                          'expirationDatePosition',
                          `${I18n.t('BEE2035' /* Data Vencimento */)}:`,
                          `${I18n.t(
                            'BEE4594', /* Informe a posição do campo %{0}. */
                            { 0: I18n.t('BEE2035' /* Data Vencimento */) },
                          )}`,
                          'number',
                          false,
                          disableExpirationDatePosition,
                          undefined,
                          3,
                        ),
                        formContext.createInput(
                          manufacturingDatePosition,
                          'manufacturingDatePosition',
                          `${I18n.t('BEE488' /* Data de Fabricação */)}:`,
                          `${I18n.t(
                            'BEE4594', /* Informe a posição do campo %{0}. */
                            { 0: I18n.t('BEE488' /* Data de Fabricação */) },
                          )}`,
                          'number',
                          false,
                          disableManufacturingDatePosition,
                          undefined,
                          3,
                        ),
                        formContext.createInput(
                          quantityPosition,
                          'quantityPosition',
                          `${I18n.t('BEE441' /* Quantidade */)}:`,
                          `${I18n.t(
                            'BEE4594', /* Informe a posição do campo %{0}. */
                            { 0: I18n.t('BEE441' /* Quantidade */) },
                          )}`,
                          'number',
                          false,
                          disableQuantityPosition,
                          undefined,
                          3,
                        ),
                      ]}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="d-flex align-items-center mb-md-3 mb-1">
                    <h1 className="page-header mb-0">
                      {I18n.t('BEE4597' /* Formato */)}
                    </h1>
                  </div>
                  <div className="col-xl-12">
                    <Form
                      noPanel
                      setValue={this.setValue}
                      setValueDrop={this.setValueDrop}
                      inputs={(formContext) => [
                        formContext.createInput(
                          expirationDateFormat,
                          'expirationDateFormat',
                          `${I18n.t('BEE2035' /* Data Vencimento */)}:`,
                          `${I18n.t(
                            'BEE4598', /* Informe o formato do campo %{0}. */
                            { 0: I18n.t('BEE2035' /* Data Vencimento */) },
                          )}. (Ex. DD/MM/AAAA)`,
                          'text',
                          false,
                          disableExpirationDateFormat,
                          undefined,
                          3,
                        ),
                        formContext.createInput(
                          manufacturingDateFormat,
                          'manufacturingDateFormat',
                          `${I18n.t('BEE488' /* Data de Fabricação */)}:`,
                          `${I18n.t(
                            'BEE4598', /* Informe o formato do campo %{0}. */
                            { 0: I18n.t('BEE488' /* Data de Fabricação */) },
                          )}. (Ex. DD/MM/AAAA)`,
                          'text',
                          false,
                          disableManufacturingDateFormat,
                          undefined,
                          3,
                        ),
                      ]}
                    />
                  </div>
                </div>
              </PanelBody>
              <PanelFooter>
                <Link to={{ pathname: ROUTES.QR_CODE_CONFIG_LIST, state: { dice: this.props.location.dice } }}>
                  {(showCancel
                    ? (
                      <OneClickButton
                        type="submit"
                        className="btn btn-120 btn-white p-5 m-5"
                      >
                        {I18n.t('BEE99' /* Cancelar */)}
                      </OneClickButton>
                    )
                    : (
                      <OneClickButton
                        type="submit"
                        className="btn btn-120 btn-white p-5 m-5"
                      >
                        {I18n.t('BEE137' /* Voltar */)}
                      </OneClickButton>
                    ))}
                </Link>
                {(showCreate
                  && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.createQRCodeConfigSubmit()}
                    >
                      {I18n.t('BEE138' /* Criar */)}

                    </OneClickButton>
                  )
                )}
                {(showUpdate
                  && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updateQRCodeConfigSubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}

                    </OneClickButton>
                  )
                )}
              </PanelFooter>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getQRCodeConfig: (qrCodeConfigId) => dispatch(getQRCodeConfig(qrCodeConfigId)),
  createQRCodeConfig: (QRCodeConfig) => dispatch(createQRCodeConfig(QRCodeConfig)),
  updateQRCodeConfig: (QRCodeConfig) => dispatch(updateQRCodeConfig(QRCodeConfig)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QRCodeConfigForm));
